import React, { useEffect, useRef, useState } from "react";
import Eye from "../assets/img/eye.svg";
import EyeSlash from "../assets/img/eye-slash.svg";
import XCircle from "../assets/img/x.svg";

const HideShowPassword = ({ showPassword, setShowPassword }) => {
  return (
    <span
      className="password-icon"
      onClick={() => setShowPassword(!showPassword)}
    >
      {showPassword ? (
        <img src={EyeSlash} alt="Ocultar contrasena" />
      ) : (
        <img src={Eye} alt="Mostrar contrasena" />
      )}
    </span>
  );
};

const InputInvalidIcon = ({ isValid }) => {
  return (
    <span className={`invalid-icon ${!isValid ? "shown" : "hidden"}`}>
      <img src={XCircle} alt="Input invalido" />
    </span>
  );
};

const TextInput = ({ placeholder, type, name, onChange, value, className, noDots }) => {
  const [isFocused, setIsFocused] = useState(value ? true : false);
  const [wasFocused, setWasFocused] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const [showPassword, setShowPassword] = useState(false);

  const handleFocus = () => {
    setIsFocused(true);
    setIsValid(true);
  };

  const handleBlur = (e) => {
    if (e.target.value) return;
    setIsFocused(false);
    setWasFocused(true);
  };

  useEffect(() => {
    if (value === "" && !isFocused) {
      setIsFocused(false);
    }
  }, [value]);

  useEffect(() => {
    if (!value && wasFocused && !isFocused) {
      setIsValid(false);
    }
  }, [value, wasFocused, isFocused]);

  const handleKeyDown = (e) => {
    if (noDots && e.key === '.') {
      e.preventDefault();
    }
  };

  const handleChange = (e) => {
    if (noDots) {
      // Eliminar los puntos del valor ingresado
      const cleanValue = e.target.value.replace(/\./g, '');
      
      // Crear un evento sintético con el valor limpio
      const syntheticEvent = {
        ...e,
        target: {
          ...e.target,
          value: cleanValue
        }
      };
      
      // Llamar al onChange original con el evento modificado
      onChange(syntheticEvent);
    } else {
      // Comportamiento normal
      onChange(e);
    }
  };

  return (
    <div
      className={`text-input-wrapper ${
        isFocused ? "focused" : ""
      } ${className} ${!isValid ? "invalid" : ""}`}
    >
      <label htmlFor={name}>{placeholder}</label>
      <input
        type={showPassword ? "text" : type}
        name={name}
        className="text-input"
        onFocus={handleFocus}
        onBlur={(e) => handleBlur(e)}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        value={value}
      />
      {type === "password" ? (
        <HideShowPassword
          showPassword={showPassword}
          setShowPassword={setShowPassword}
        />
      ) : (
        <InputInvalidIcon isValid={isValid} />
      )}
    </div>
  );
};

export default TextInput;